import { z } from "zod";
import { MetaSchema } from "./shared";

export const GroupedPackageSchema = z.object({
  count: z.number(),
  amount: z.string(),
});

export const LatestPackageSchema = z.object({
  start: z.string().datetime(),
  end: z.string().datetime(),
});

export const PrincipalReturnsSummaryDataSchema = z.object({
  count: z.number(),
  totalInvestedInPrincipalReturnPeriod: z.number().nullable(),
  totalPrincipalReturns: z.number(),

  groupedPackages: z.array(GroupedPackageSchema),

  latestPackage: LatestPackageSchema.nullable(),
});

const UsersInvestmentsPrincipalReturnsSummaryResponse = z.object({
  data: PrincipalReturnsSummaryDataSchema,
  meta: MetaSchema.default,
});

export type UsersInvestmentsPrincipalReturnsSummaryResponseType = z.infer<
  typeof UsersInvestmentsPrincipalReturnsSummaryResponse
>;

export default UsersInvestmentsPrincipalReturnsSummaryResponse;
